import { useFeatureGate } from '@statsig/expo-bindings';

import { FeatureFlags } from '../../../feature-flags/FeatureFlags';
import { useMoneyMapWorkflow } from '../../../roadmap/hooks/useMoneyMapWorkflow';
import useGetExistingIncomeSplitConfigs from '../../components/income-split/hooks/useGetIncomeSplitConfigs';

const useShouldSeeTiedRules = () => {
    const { value: enableTiedRules } = useFeatureGate(
        FeatureFlags.ENABLE_TIED_RULES,
    );

    const { incomeSplitConfigs } = useGetExistingIncomeSplitConfigs();

    const { moneyMap, moneyMapCompleteness } = useMoneyMapWorkflow();

    // if a membership is in the test, or is excluded from the test but has been migrated over to a tied rules income split via a money map,
    // then they should see the tied rules experience
    return (
        enableTiedRules ||
        incomeSplitConfigs.length > 0 ||
        ((moneyMap?.moneyMapRuleGroups ?? []).length > 0 &&
            moneyMapCompleteness.incomeSplitStep.isCompleteForMembership &&
            !!incomeSplitConfigs.length)
    );
};

export default useShouldSeeTiedRules;
